import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/common/Icon';
import { VimeoIcon, YouTubeIcon, SoundCloudIcon } from 'components/common/serviceIcons';
import {
  MEDIA_SOURCE_URL, MEDIA_SOURCE_LIBRARY,
  VIMEO_URL_PATTERN, YOUTUBE_URL_PATTERN, SOUNDCLOUD_URL_PATTERN,
} from './';

const ItemThumbnail = ({
  mediaSource,
  media,
  mediaUrl,
  layout,
  mediaObject,
}) => {
  if (mediaSource === MEDIA_SOURCE_LIBRARY && media) {
    return mediaObject ? (
      <div className="title-builder-item-thumbnail mr-4">
        <img src={mediaObject.thumbnail} alt="thumbnail" width="100" height="60" />
      </div>
    ) : (
      <div className="title-builder-item-thumbnail mr-4">
        <Icon name="steppers" />
      </div>
    );
  } else if (mediaSource === MEDIA_SOURCE_URL && mediaUrl) {
    if (VIMEO_URL_PATTERN.test(mediaUrl)) {
      return (
        <div className="title-builder-item-thumbnail vimeo mr-4">
          <VimeoIcon fill="currentColor" />
        </div>
      );
    } else if (YOUTUBE_URL_PATTERN.test(mediaUrl)) {
      return (
        <div className="title-builder-item-thumbnail youtube mr-4">
          <YouTubeIcon fill="currentColor" />
        </div>
      );
    } else if (SOUNDCLOUD_URL_PATTERN.test(mediaUrl)) {
      return (
        <div className="title-builder-item-thumbnail soundcloud mr-4">
          <SoundCloudIcon fill="currentColor" />
        </div>
      );
    }
  } else if (layout === 'quote') {
    return (
      <div className="title-builder-item-thumbnail mr-4">
        <Icon name="format_quote" fill size={36} />
      </div>
    );
  } else {
    return (
      <div className="title-builder-item-thumbnail mr-4">
        <Icon name="content_copy" />
      </div>
    );
  }
};

ItemThumbnail.propTypes = {
  mediaSource: PropTypes.string,
  media: PropTypes.string,
  mediaUrl: PropTypes.string,
  layout: PropTypes.oneOf(['', 'quote', 'blocks']),
  mediaObject: PropTypes.shape({
    thumbnail: PropTypes.string,
  }),
};

export default ItemThumbnail;
